




import {Component, Prop} from 'vue-property-decorator';
import EntityType from "@/models/Shared/EntityType";
import ComponentLocation from '@/models/Shared/ComponentLocation';
import GiganautVue from '@/components/Shared/GiganautVue';


@Component({
  name: 'OpenEntityInCurrentWindowLink',
})
export default class extends GiganautVue {

	@Prop()
	location: ComponentLocation;
	@Prop({required: true})
	entityId: string;
	@Prop({required: true})
	entityType: EntityType;
	@Prop({required: true})
	entityName: string;

	get url() {
		switch (this.entityType) {
			case EntityType.Worker:
				return "/agency/workers/" + this.entityId;
				break;
			case EntityType.Location:
				return "/agency/locations/" + this.entityId;
				break;
			case EntityType.Contact:
			return "/agency/contacts/" + this.entityId;
				break;
			case EntityType.Booking:
				return "/agency/bookings/" + this.entityId;
				break;
			case EntityType.Company:
				return "/agency/companies/" + this.entityId;
				break;
			case EntityType.Job:
				return "/agency/jobs/" + this.entityId;
				break;
			default:
				break;
		}
  }
	
}
